import FlowIconSquare from '@Client/runner.directives/common/FlowIconSquare/FlowIconSquare';
import FlowModelSummaryTag from '@Client/runner.shared/FlowModelSummaryTag/FlowModelSummaryTag';
import IReportFlowModelDetail from '@Shared.Angular/@types/core/contracts/queryModel/reports/reportFlowModelDetail';
import React from 'react';

interface ReportHeaderProps {
  flowModel: IReportFlowModelDetail;
  isMobile?: boolean;
  onClick: (flow: IReportFlowModelDetail) => void;
}

const ReportHeader: React.FC<ReportHeaderProps> = ({
  flowModel,
  isMobile = false,
  onClick
}) => {
  return (
    <div className={`flow-start ${isMobile ? 'isMobile' : ''}`}>
      <div
        className="flow-start-header flex flex-row"
        onClick={() => onClick(flowModel)}
      >
        {!isMobile && (
          <>
            <FlowIconSquare name={flowModel.flowModelName} flowCode="" />

            <div className="report-header__right-container">
              <div className="flow-list__contents flex flex-row">
                <div className="flow-list__contents__subject">
                  <div className="flow-list__contents__subject__text">
                    {flowModel.flowModelName}
                  </div>
                  <div className="flow-list__contents__subject__category">
                    {flowModel.category}
                  </div>
                </div>

                <div className="flow-list__contents__description">
                  {flowModel.description}
                </div>

                <div className="flow-list__contents__process-owner">
                  <div className="flow-list__contents__process-owner__text">
                    Process Owner: {flowModel.processOwnerName || '--'}
                  </div>
                </div>

                <div className="tags">
                  {!flowModel.active && (
                    <div className="chip grey-chip">Deleted</div>
                  )}
                </div>
              </div>

              {flowModel.parsedTags?.length > 0 && (
                <div className="report-header-right__tag-row">
                  <FlowModelSummaryTag tags={flowModel.parsedTags} />
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ReportHeader;
